import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { permissionsSelector } from "../../Login/selectors/permissionSelector";
import { OfficeAppliancesTabs } from "./OfficeAppliancesTabs";
const Submenu = () => {
  const userPermissions = useRecoilValue(permissionsSelector);
  const { pathname } = useLocation();
  const [hover, setHover] = useState<any>();
  const index1 = OfficeAppliancesTabs.findIndex((tab) => pathname === tab.to);

  return (
    <div>
      <div className="pl-4 py-4 rounded-l-lg bg-quinary">
        {OfficeAppliancesTabs.filter((item) =>
          userPermissions.includes(item.permission)
        ).map((item, index) => {
          const isActive = item.to === pathname;

          const shouldRoundLeft =
            hover === index ||
            index === hover - 1 ||
            index === OfficeAppliancesTabs.length - 1 ||
            index1 === index + 1;

          const borderClass = shouldRoundLeft
            ? "rounded-l-lg"
            : "border-b border-septenary border-opacity-25";

          const className = isActive
            ? "bg-white rounded-l-lg text-secondary flex items-center font-medium p-2 sidebar-text-size"
            : `flex items-center text-white bg-quinary sidebar-text-size
         ${borderClass}
         hover:bg-secondary p-2 sidebar-text-size`;

          return (
            <Link
              key={item.to}
              to={item.to}
              onMouseEnter={() => setHover(index)}
              onMouseLeave={() => setHover(undefined)}
              className={className}
            >
              {item.title}
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default Submenu;
